import { __extends, __spreadArrays } from "tslib";
import * as React from 'react';
import { translate } from 'react-i18next';
import ChevronDown from 'wix-ui-icons-common/ChevronDown';
import { TextButton, DropdownBase, Box, FormField } from 'wix-style-react';
var BuiltInFieldLabel = /** @class */ (function (_super) {
    __extends(BuiltInFieldLabel, _super);
    function BuiltInFieldLabel(props) {
        var _this = _super.call(this, props) || this;
        var tagId = props.field &&
            props.field.value &&
            props.field.value.tag;
        _this.state = {
            isOpen: false,
            tagId: tagId || '',
        };
        return _this;
    }
    BuiltInFieldLabel.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.field.value.tag !==
            this.props.field.value.tag) {
            this.setState({
                tagId: this.props.field.value.tag,
            });
        }
    };
    BuiltInFieldLabel.prototype.renderFieldTagsOptions = function () {
        var _a = this.props, t = _a.t, field = _a.field;
        if (field.tags && field.tags.length) {
            return __spreadArrays(field.tags, ['other']).map(function (fieldTag) { return ({
                id: fieldTag === 'other' ? '' : fieldTag,
                value: t("editContact.field." + field.id + ".tags." + fieldTag),
            }); });
        }
        return [];
    };
    BuiltInFieldLabel.prototype.handleSelectTagClick = function (tagId) {
        this.props.onFieldTagChange(tagId);
        this.setState({ tagId: tagId, isOpen: false });
    };
    BuiltInFieldLabel.prototype.render = function () {
        var _this = this;
        var _a = this.props, t = _a.t, field = _a.field;
        var enableDropdown = field.tags &&
            field.tags.length !== 0;
        return (React.createElement("div", { "data-hook": "field-label-" + field.id },
            React.createElement(DropdownBase, { fluid: true, dynamicWidth: true, appendTo: "window", zIndex: 5500, dataHook: "field-label-" + field.id + "-dropdown", options: this.renderFieldTagsOptions(), onSelect: function (tag) { return _this.handleSelectTagClick(tag.id); }, open: this.state.isOpen, onClickOutside: function () { return _this.setState({ isOpen: false }); } },
                React.createElement(TextButton, { fluid: true, placement: "top", skin: "dark", dataHook: "field-label-text-" + field.id + "-" + (field
                        .index || 0), onClick: enableDropdown
                        ? function () { return _this.setState({ isOpen: !_this.state.isOpen }); }
                        : null },
                    React.createElement(FormField, { dataHook: "field-label-formField-" + field.id + "-" + (field.index || 0), label: t("editContact.field." + field.id + ".tags." + (this.state.tagId ||
                            'default')), required: this.props.required, suffix: enableDropdown ? (React.createElement(Box, null,
                            React.createElement(ChevronDown, null))) : null })))));
    };
    return BuiltInFieldLabel;
}(React.PureComponent));
export default translate()(BuiltInFieldLabel);
//# sourceMappingURL=BuiltInFieldLabel.js.map